module.exports = __webpack_public_path__ + "img/icon_mini_download.6e0097ac.svg";